// ErrorHero.jsx
import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you're using react-router

const ErrorHero = () => {
  return (
    <div className="error-hero">
      <div className="error-container">
        <div className="error-content">
          <h1 className="error-title">
            Lost in the AI Void
          </h1>
          <img 
            src="https://i.imgur.com/lUcmZkI.gif" 
            alt="Error Robot" 
            className="error-gif"
          />
          <p className="error-message">
            Oops! It seems you've drifted into uncharted digital space.
          </p>
          <Link to="/" className="home-button">
            Return to Home
          </Link>
        </div>
      </div>

      <style jsx>{`
        .error-hero {
          min-height: 100vh;
          width: 100%;
          background: linear-gradient(135deg, #1a0b2e 0%, #2e1a47 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 80px 16px 40px; /* Account for fixed navbar */
        }

        .error-container {
          max-width: 7xl;
          margin: 0 auto;
          width: 100%;
          position: relative;
          z-index: 5;
        }

        .error-content {
          text-align: center;
          padding: 32px;
          background: rgba(26, 11, 46, 0.7);
          border: 1px solid rgba(168, 85, 247, 0.3);
          border-radius: 12px;
          backdrop-filter: blur(5px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
          animation: float 3s ease-in-out infinite;
        }

        .error-title {
          font-size: 2.5rem;
          font-weight: 700;
          background: linear-gradient(90deg, #3b82f6, #a855f7, #ec4899);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          text-shadow: 0 2px 8px rgba(168, 85, 247, 0.5);
          margin-bottom: 24px;
        }

        .error-gif {
          max-width: 300px;
          width: 100%;
          height: auto;
          margin: 0 auto 24px;
          filter: drop-shadow(0 0 15px rgba(147, 51, 234, 0.7));
          transition: transform 0.3s ease;
        }

        .error-gif:hover {
          transform: scale(1.1) rotate(5deg);
        }

        .error-message {
          color: #d1d5db;
          font-size: 1.2rem;
          margin-bottom: 32px;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
        }

        .home-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          border-radius: 10px;
          background: linear-gradient(135deg, #ec4899, #a855f7);
          border: 1px solid rgba(236, 72, 153, 0.5);
          color: #ffffff;
          font-size: 1rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(236, 72, 153, 0.5);
        }

        .home-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(120deg, transparent, rgba(236, 72, 153, 0.4), transparent);
          transition: all 0.5s ease;
          z-index: -1;
        }

        .home-button:hover::before {
          left: 100%;
        }

        .home-button:hover {
          background: linear-gradient(135deg, #f472b6, #8b5cf6);
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 6px 20px rgba(236, 72, 153, 0.7);
        }

        /* Cosmic particle effect */
        .error-hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(168, 85, 247, 0.1) 0%, transparent 70%);
          animation: pulse 10s infinite;
          z-index: 1;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .error-hero {
            padding: 60px 12px 20px;
          }

          .error-content {
            padding: 24px;
          }

          .error-title {
            font-size: 1.8rem;
          }

          .error-gif {
            max-width: 200px;
          }

          .error-message {
            font-size: 1rem;
          }

          .home-button {
            padding: 10px 20px;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .error-title {
            font-size: 1.5rem;
          }

          .error-gif {
            max-width: 150px;
          }

          .error-message {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ErrorHero;